// After a deploy, an open tab may ask for a JS chunk that no longer exists. Reload once to get
// the new version; the sessionStorage timestamp keeps a broken deploy from causing a reload loop.
const KEY = "ordexa/chunk-reload-at";
const WINDOW_MS = 60 * 1000;
const CHUNK_ERROR = /ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed/i;

export function isChunkError(error) {
  if (!error) return false;
  return CHUNK_ERROR.test(`${error.name || ""} ${error.message || error}`);
}

// Returns true when a reload was started.
export function reloadOnceForChunkError(url) {
  try {
    const last = Number(sessionStorage.getItem(KEY)) || 0;
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch (e) {
    return false; // no storage: better a visible error than a reload loop
  }
  if (url) window.location.assign(url);
  else window.location.reload();
  return true;
}

export function installChunkReload() {
  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkError(event.reason)) reloadOnceForChunkError();
  });
}
